import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statusRoad: null,
  ticketById: null,
  flags: null,
  ticketCategory: [],
  employeeTicket: [],
  refubishedTicket: {
    flags: {},
    ticket: {},
    status_road: [],
  },
}

const parseLocalizedDate = (dateStr) => {
  if (!dateStr || dateStr === '-') return '';
  try {
    const parts = dateStr.split(', ');
    if (parts.length < 2) return dateStr;
    const dateParts = parts[0].split('/');
    if (dateParts.length < 3) return dateStr;
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    let year = parseInt(dateParts[2], 10);
    if (year < 100) year += 2000;

    const timeParts = parts[1].split(' ');
    const timeNumParts = timeParts[0].split(':');
    let hours = parseInt(timeNumParts[0], 10);
    const minutes = parseInt(timeNumParts[1], 10);
    const isPM = parts[1]?.toLowerCase().includes('p');
    if (isPM && hours < 12) hours += 12;
    if (!isPM && hours === 12) hours = 0;

    const date = new Date(year, month, day, hours, minutes);
    return isNaN(date.getTime()) ? dateStr : date.toISOString();
  } catch (e) {
    return dateStr;
  }
};

export const detailTicketByIdSlice = createSlice({
  name: "detailTicketById",
  initialState,
  reducers: {
    setTicketRefubishedById: (state, { payload }) => {
      const { data } = payload;
      state.refubishedTicket = data;
    },
    setTicketById: (state, { payload }) => {
      const { data, ticketId } = payload;
      state.statusRoad = data?.statusRoad || data?.status_road;
      
      if (data?.ticket && 'ticket_code' in data.ticket) {
        state.ticketById = {
          ...data.ticket,
          id: data.ticket.id || data.ticket.ticket_id || ticketId,
          code: data.ticket.ticket_code,
          created_at: parseLocalizedDate(data.ticket.ticket_creation_date),
          updated_at: parseLocalizedDate(data.ticket.ticket_update_date),
          TICKET_DETAIL: {
            title: data.ticket.ticket_title,
            description: data.ticket.description,
            TICKET_DETAIL_IMAGEs: data.ticket.ticket_images || [],
            TICKET_DETAIL_FILEs: data.ticket.ticket_files || [],
            TICKET_DETAIL_VIDEOs: data.ticket.ticket_videos || [],
          },
          TICKET_RESIDENTIAL: {
            houseName: data.ticket.place_name,
            nomenclatureName: data.ticket.place_address,
          },
          TICKET_CATEGORY: {
            id: data.ticket.ticket_category_id,
            name: data.ticket.ticket_category_name,
          },
          TICKET_SUBCATEGORY: {
            id: data.ticket.ticket_subcategory_id,
            name: data.ticket.ticket_subcategory_name,
          },
          TICKET_TYPE: {
            name: data.ticket.ticket_type_name,
          },
          TICKET_STATUS: {
            name: data.ticket.assignment_history?.[data.ticket.assignment_history.length - 1]?.status_name || '',
          },
          TICKET_EMPLOYEE: data.ticket.current_employee ? {
            employeeId: data.ticket.current_employee.employee_id,
            created_at: parseLocalizedDate(data.ticket.current_employee.status?.label?.match(/\(([^)]+)\)/)?.[1]),
            TICKET_EMPLOYEE_STATUS: {
              name: data.ticket.current_employee.status?.label?.split(' (')[0] || '',
            },
            EMPLOYEE: {
              name: data.ticket.current_employee.full_name,
              EMPLOYEE_DEPARTMENT: {
                COMPANY_DEPARTMENT: {
                  name: data.ticket.current_employee.department_name,
                }
              }
            }
          } : null,
          TICKET_EMPLOYEE_LOG: data.ticket.assignment_history?.map(log => ({
            employee_name: log.full_name,
            assignment_date: parseLocalizedDate(log.assignment_update_date),
            ticket_status: log.status_name,
          })) || [],
          TICKET_INSPECTION: data.ticket.inspection,
          TICKET_FINAL_NOTE: data.ticket.final_note,
        };
      } else {
        state.ticketById = data?.ticket;
      }
      state.flags = data?.flags;
    },
    setTicketCategory: (state, { payload }) => {
      const { data } = payload;
      state.ticketCategory = data;
    },
    setEmployee: (state, { payload }) => {
      const { data } = payload;
      state.employeeTicket = data?.dataSource;
    },
    cleanTicketById: (state) => {
      state.statusRoad = null;
      state.ticketById = null;
      state.flags = null;
      state.ticketCategory = [];
      state.employeeTicket = [];
      state.refubishedTicket = {
        flags: {},
        ticket: {},
        status_road: [],
      };
    },

  },
});

export const { setTicketById, setTicketCategory, setEmployee, setTicketRefubishedById, cleanTicketById } =
  detailTicketByIdSlice.actions;
